export const getEducationLevelLabel = (value, t) => {
  switch (value) {
    case 'Ensino Fundamental':
      return t('education_elementary');
    case 'Ensino Médio':
      return t('education_high_school');
    case 'Ensino Superior':
      return t('education_higher');
    default:
      return value;
  }
};

export const getDifficultyLabel = (value, t) => {
  switch (value) {
    case 'Fácil':
      return t('difficulty_easy');
    case 'Médio':
      return t('difficulty_medium');
    case 'Difícil':
      return t('difficulty_hard');
    default:
      return value;
  }
};

export const getQuestionTypeLabel = (value, t) => {
  switch (value) {
    case 'Questão objetiva':
    case 'simples':
      return t('question_objective');
    case 'Questão dissertativa':
    case 'dissertativa':
      return t('question_discursive');
    case 'conjunto':
      return t('question_group_objective_common');
    default:
      return value;
  }
};
